import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map, takeUntil, take, mergeMap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, combineLatest, EMPTY } from 'rxjs';
import * as i2$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i1$1 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { getStepDetails, getDataSourceCountryList, SetDataSourceCountryList, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { sync_entity_relationship_details_document_code } from 'permission-library';
import * as i3 from 'reference-library';
import * as i4 from 'cache-country-list';
import * as i7 from 'step-status-update-payload-service';
import * as i8 from 'step-status-update-component-library';

class ApiEnterEntitiesRelationshipDetailsLibraryService {
    constructor(http, toastrService) {
        this.http = http;
        this.toastrService = toastrService;
    }
    onGetEntityRelationshipDetails(primaryData) {
        return this.http
            .get(`/${primaryData.visatype}/${primaryData.caseType}/${primaryData.caseId}/company/${primaryData.companyId}/entitiesInfo`)
            .pipe(map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    onGetUSCompanyAdditionalDetails(primaryData) {
        return this.http
            .get(`/${primaryData.visatype}/${primaryData.caseType}/${primaryData.caseId}/company/${primaryData.companyId}/ownership/list`)
            .pipe(map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
    onSaveUSCompanyAdditionalDetails(payload, primaryData) {
        return this.http
            .post(`/${primaryData.visatype}/${primaryData.caseType}/${primaryData.caseId}/company/${primaryData.companyId}/ownership/add`, payload)
            .pipe(map((response) => {
            if (response.status === 200 && response.message) {
                this.toastrService.success(response.message, 'Success');
                return true;
            }
            else {
                return false;
            }
        }));
    }
    onSaveEntityRelationshipDetails(payload, primaryData) {
        return this.http
            .post(`/${primaryData.visatype}/${primaryData.caseType}/${primaryData.caseId}/company/${primaryData.companyId}/add`, payload)
            .pipe(map((response) => {
            if (response.status === 200 && response.message) {
                this.toastrService.success(response.message, 'Success');
                return true;
            }
            else {
                return false;
            }
        }));
    }
    onDeleteUSCompanyAdditionalDetails(ownershipId, primaryData) {
        return this.http
            .delete(`/${primaryData.visatype}/${primaryData.caseType}/${primaryData.caseId}/company/${primaryData.companyId}/ownership/${ownershipId}/delete`)
            .pipe(map((response) => {
            if (response.status === 200 && response.message) {
                this.toastrService.success(response.message, 'Success');
                return true;
            }
            else {
                return false;
            }
        }));
    }
}
ApiEnterEntitiesRelationshipDetailsLibraryService.ɵfac = function ApiEnterEntitiesRelationshipDetailsLibraryService_Factory(t) { return new (t || ApiEnterEntitiesRelationshipDetailsLibraryService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ToastrService)); };
ApiEnterEntitiesRelationshipDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ApiEnterEntitiesRelationshipDetailsLibraryService, factory: ApiEnterEntitiesRelationshipDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiEnterEntitiesRelationshipDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.ToastrService }]; }, null); })();

class BaseEnterEntitiesRelationshipDetailsLibraryService {
    constructor(guard, store, referenceLibraryService, cacheCountyService, toastrService, apiEnterEntitiesRelationshipDetailsLibraryService, stepStatusUpdatePayloadService, stepStatusUpdateComponentLibraryService) {
        this.guard = guard;
        this.store = store;
        this.referenceLibraryService = referenceLibraryService;
        this.cacheCountyService = cacheCountyService;
        this.toastrService = toastrService;
        this.apiEnterEntitiesRelationshipDetailsLibraryService = apiEnterEntitiesRelationshipDetailsLibraryService;
        this.stepStatusUpdatePayloadService = stepStatusUpdatePayloadService;
        this.stepStatusUpdateComponentLibraryService = stepStatusUpdateComponentLibraryService;
        this.observableSubscription$ = new Subject();
        this.USCompanyAdditionalDetailsArray = [];
        this.resetForm = {
            id: null,
            companyId: null,
            relationshipBetCompany: {
                relationshipBetCompanyInfo: null
            },
            principalProductOrService: {
                principalProductOrServiceInfo: null
            },
            USCompanyAdditionalDetails: {
                detailsForm: {
                    id: null,
                    companyId: null,
                    compOwnTypeCode: null,
                    compOwnTypeId: null,
                    firstName: null,
                    lastName: null,
                    middleName: null,
                    corporateName: null,
                    nationality: null,
                    immigrationStatusCode: null,
                    immigrationStatusId: null,
                    ownershipPercent: null
                }
            },
            assetsNetWorthNetAnnualIncomeDetails: {
                assets: null,
                netWorth: null,
                netAnnualIncome: null
            },
            otherRequiredDetails: {
                numTotExecMngrEmp: null,
                numExecMngrEmpEHLStat: null,
                numTotPosSpecQual: null,
                numPosSpecQualEHLStat: null,
                numEmpBenSuprvs: null
            },
            TradeDetailsE1: {
                totAnnualGrossTrade: null,
                totAnnualGrossTradeYrEnd: null,
                totPercGrossTradeUSTrtyCntry: null
            },
            investmentDetailsE2: {
                invstmntCash: null,
                invstmntEquipment: null,
                invstmntOther: null,
                invstmntInvntry: null,
                invstmntPremise: null,
                invstmntTotal: null
            }
        };
        this.fields = {
            showTradeDetails: true,
            showInvestmentDetails: false
        };
        this.initialRefLibrary = {
            code: null,
            desc: null,
            group: null,
            id: null,
            name: 'Select'
        };
        this.initialCountry = {
            code: null,
            name: 'Select',
            createdBy: null,
            modifiedBy: null,
            phoneCode: null,
            sequenceNumber: null,
            shortCountryCode: null
        };
        this.USCompanyAdditionalDetailsSubmited = false;
    }
    loadInit() {
        switch (this.primaryData.visatype) {
            case 'E1':
                this.fields = {
                    showTradeDetails: true,
                    showInvestmentDetails: false
                };
                break;
            case 'E2':
            case 'E2C':
                this.fields = {
                    showTradeDetails: false,
                    showInvestmentDetails: true
                };
                break;
        }
        this.enterRelationshipDetailsForm = new FormGroup({
            id: new FormControl(null),
            companyId: new FormControl(null),
            relationshipBetCompany: new FormGroup({
                relationshipBetCompanyInfo: new FormControl(null, Validators.required)
            }),
            principalProductOrService: new FormGroup({
                principalProductOrServiceInfo: new FormControl(null, Validators.required)
            }),
            USCompanyAdditionalDetails: new FormGroup({
                detailsForm: new FormGroup({
                    id: new FormControl(null),
                    companyId: new FormControl(null),
                    compOwnTypeCode: new FormControl(null),
                    compOwnTypeId: new FormControl(null),
                    firstName: new FormControl(null),
                    lastName: new FormControl(null),
                    middleName: new FormControl(null),
                    corporateName: new FormControl(null),
                    nationality: new FormControl(null),
                    immigrationStatusCode: new FormControl(null),
                    immigrationStatusId: new FormControl(null),
                    ownershipPercent: new FormControl(null)
                }, [this.validateUSCompanyAdditionalDetails])
            }),
            assetsNetWorthNetAnnualIncomeDetails: new FormGroup({
                assets: new FormControl(null, Validators.required),
                netWorth: new FormControl(null, Validators.required),
                netAnnualIncome: new FormControl(null, Validators.required)
            }),
            otherRequiredDetails: new FormGroup({
                numTotExecMngrEmp: new FormControl(null, Validators.required),
                numExecMngrEmpEHLStat: new FormControl(null, Validators.required),
                numTotPosSpecQual: new FormControl(null, Validators.required),
                numPosSpecQualEHLStat: new FormControl(null, Validators.required),
                numEmpBenSuprvs: new FormControl(null, Validators.required)
            }),
            TradeDetailsE1: new FormGroup({
                totAnnualGrossTrade: new FormControl(null),
                totAnnualGrossTradeYrEnd: new FormControl(null),
                totPercGrossTradeUSTrtyCntry: new FormControl(null)
            }, this.TradeDetailsE1Validation.bind(this)),
            investmentDetailsE2: new FormGroup({
                invstmntCash: new FormControl(null),
                invstmntEquipment: new FormControl(null),
                invstmntOther: new FormControl(null),
                invstmntInvntry: new FormControl(null),
                invstmntPremise: new FormControl(null),
                invstmntTotal: new FormControl(null)
            }, this.investmentDetailsE2Validation.bind(this))
        });
        this.enterRelationshipDetailsForm.valueChanges.pipe(map(() => this.enterRelationshipDetailsForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.store.pipe(select(getStepDetails, { id: this.primaryData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
            this.stepDetails = data;
            this.disabledControls =
                this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE' ||
                    this.stepDetails.stepStatusDetails.stepStatusCode === 'SUBMIT';
            if (this.disabledControls) {
                this.enterRelationshipDetailsForm.disable();
            }
            else {
                this.enterRelationshipDetailsForm.enable();
            }
            this.store.dispatch(new MarkCleanFormAction({
                dirty: false
            }));
            this.setFileUploadUSConfigurations();
        });
        combineLatest([
            this.referenceLibraryService.getReferenceData('COMPOWNTYP'),
            this.store.pipe(select(getDataSourceCountryList)),
            this.referenceLibraryService.getReferenceData('IMMSTAT'),
        ])
            .pipe(take(1))
            .subscribe(([responseCompanyTypList, repsonseNationalityList, responseImmigrationStatusList]) => {
            this.companyTypList = responseCompanyTypList;
            if (repsonseNationalityList && repsonseNationalityList.length > 0) {
                this.nationalityList = [this.initialCountry, ...repsonseNationalityList];
            }
            else {
                this.referenceLibraryService.getDataSource('COUNTRY', '')
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.nationalityList = [this.initialCountry, ...response];
                    this.store.dispatch(new SetDataSourceCountryList(response || null));
                });
            }
            this.nationalityList = [this.initialCountry, ...repsonseNationalityList];
            this.immigrationStatusList = [this.initialRefLibrary, ...responseImmigrationStatusList];
            const currentYear = new Date().getFullYear();
            const previousYear = currentYear - 1;
            this.yearEndingList = [{
                    label: 'Select',
                    value: null
                }, {
                    label: String(previousYear),
                    value: previousYear
                }, {
                    label: String(currentYear),
                    value: currentYear
                }];
            this.getEntityRelationshipDetails();
        });
    }
    TradeDetailsE1Validation(group) {
        if (this.primaryData.visatype === 'E1' &&
            (group.value.totAnnualGrossTrade === null || !group.value.totAnnualGrossTradeYrEnd ||
                group.value.totPercGrossTradeUSTrtyCntry === null)) {
            return { TradeDetailsE1IsRequired: true };
        }
        return null;
    }
    investmentDetailsE2Validation(group) {
        if (['E2', 'E2C'].includes(this.primaryData.visatype) &&
            (group.value.invstmntCash === null || group.value.invstmntEquipment === null ||
                group.value.invstmntOther === null || group.value.invstmntInvntry === null ||
                group.value.invstmntPremise === null)) {
            return { investmentDetailsE2IsRequired: true };
        }
        return null;
    }
    validateUSCompanyAdditionalDetails(group) {
        if ((!group.value.compOwnTypeCode && !group.value.nationality && !group.value.immigrationStatusId &&
            (!group.value.firstName || (group.value.firstName && group.value.firstName.trim() === '')) &&
            (!group.value.lastName || (group.value.lastName && group.value.lastName.trim() === '')) &&
            group.value.ownershipPercent === null &&
            (!group.value.corporateName || (group.value.corporateName && group.value.corporateName.trim() === ''))) ||
            (group.value.compOwnTypeCode && group.value.nationality &&
                ((group.value.compOwnTypeCode === 'INDIVIDUAL' &&
                    (group.value.firstName && group.value.firstName.trim() !== '') &&
                    (group.value.lastName && group.value.lastName.trim() !== '') && group.value.immigrationStatusId) ||
                    (group.value.compOwnTypeCode === 'CORPORATE' &&
                        (group.value.corporateName && group.value.corporateName.trim() !== ''))) &&
                group.value.ownershipPercent !== null)) {
            return null;
        }
        return { USCompanyAdditionalDetailsIsRequired: true };
    }
    getEntityRelationshipDetails() {
        combineLatest([
            this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetEntityRelationshipDetails(this.primaryData),
            this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetUSCompanyAdditionalDetails(this.primaryData)
        ]).pipe(take(1))
            .subscribe(([responseEntityRelationshipDetails, responseUSCompanyAdditionalDetails]) => {
            this.setEntityRelationshipDetails(responseEntityRelationshipDetails);
            this.setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails);
        });
    }
    setEntityRelationshipDetails(responseEntityRelationshipDetails) {
        this.resetForm = {
            id: responseEntityRelationshipDetails.id,
            companyId: this.primaryData.companyId,
            relationshipBetCompany: {
                relationshipBetCompanyInfo: responseEntityRelationshipDetails.relationshipBetCompanyInfo
            },
            principalProductOrService: {
                principalProductOrServiceInfo: responseEntityRelationshipDetails.principalProductOrServiceInfo
            },
            USCompanyAdditionalDetails: {
                detailsForm: {
                    id: null,
                    companyId: this.primaryData.companyId,
                    compOwnTypeCode: null,
                    compOwnTypeId: null,
                    firstName: null,
                    lastName: null,
                    middleName: null,
                    corporateName: null,
                    nationality: null,
                    immigrationStatusCode: null,
                    immigrationStatusId: null,
                    ownershipPercent: null
                }
            },
            assetsNetWorthNetAnnualIncomeDetails: {
                assets: responseEntityRelationshipDetails.assets,
                netWorth: responseEntityRelationshipDetails.netWorth,
                netAnnualIncome: responseEntityRelationshipDetails.netAnnualIncome
            },
            otherRequiredDetails: {
                numTotExecMngrEmp: responseEntityRelationshipDetails.numTotExecMngrEmp,
                numExecMngrEmpEHLStat: responseEntityRelationshipDetails.numExecMngrEmpEHLStat,
                numTotPosSpecQual: responseEntityRelationshipDetails.numTotPosSpecQual,
                numPosSpecQualEHLStat: responseEntityRelationshipDetails.numPosSpecQualEHLStat,
                numEmpBenSuprvs: responseEntityRelationshipDetails.numEmpBenSuprvs
            },
            TradeDetailsE1: {
                totAnnualGrossTrade: responseEntityRelationshipDetails.totAnnualGrossTrade,
                totAnnualGrossTradeYrEnd: responseEntityRelationshipDetails.totAnnualGrossTradeYrEnd,
                totPercGrossTradeUSTrtyCntry: responseEntityRelationshipDetails.totPercGrossTradeUSTrtyCntry
            },
            investmentDetailsE2: {
                invstmntCash: responseEntityRelationshipDetails.invstmntCash,
                invstmntEquipment: responseEntityRelationshipDetails.invstmntEquipment,
                invstmntOther: responseEntityRelationshipDetails.invstmntOther,
                invstmntInvntry: responseEntityRelationshipDetails.invstmntInvntry,
                invstmntPremise: responseEntityRelationshipDetails.invstmntPremise,
                invstmntTotal: null
            }
        };
        this.enterRelationshipDetailsForm.reset(this.resetForm);
        this.calcTotalInvestmentDetails(this.resetForm.investmentDetailsE2);
    }
    setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails) {
        this.USCompanyAdditionalDetailsArray = [];
        responseUSCompanyAdditionalDetails.forEach(x => {
            this.USCompanyAdditionalDetailsArray.push({
                id: x.id,
                companyId: this.primaryData.companyId,
                compOwnTypeCode: x.compOwnTypeCode,
                compOwnTypeId: x.compOwnTypeId,
                firstName: x.firstName,
                lastName: x.lastName,
                middleName: x.middleName,
                corporateName: x.corporateName,
                nationality: x.nationality,
                immigrationStatusCode: x.immigrationStatusCode,
                immigrationStatusId: x.immigrationStatusId,
                ownershipPercent: x.ownershipPercent,
                compOwnTypeName: this.companyTypList.find(y => y.code === x.compOwnTypeCode).name,
                nationalityName: this.nationalityList.find(y => y.code === x.nationality).name,
                immigrationStatusName: x.immigrationStatusId ? this.immigrationStatusList.find(y => y.id === x.immigrationStatusId).name : '-'
            });
        });
    }
    getTotalInvestment(invstmntDetails) {
        return (invstmntDetails.invstmntCash ? invstmntDetails.invstmntCash : 0) +
            (invstmntDetails.invstmntEquipment ? invstmntDetails.invstmntEquipment : 0) +
            (invstmntDetails.invstmntOther ? invstmntDetails.invstmntOther : 0) +
            (invstmntDetails.invstmntInvntry ? invstmntDetails.invstmntInvntry : 0) +
            (invstmntDetails.invstmntPremise ? invstmntDetails.invstmntPremise : 0);
    }
    onChangeInvestment(value, formControl) {
        const invstmntDetails = Object.assign(Object.assign({}, this.enterRelationshipDetailsForm.get('investmentDetailsE2').value), { [formControl]: value || 0 });
        this.calcTotalInvestmentDetails(invstmntDetails);
    }
    calcTotalInvestmentDetails(invstmntDetailsValue) {
        this.enterRelationshipDetailsForm.get('investmentDetailsE2').patchValue({
            invstmntTotal: (new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(this.getTotalInvestment(invstmntDetailsValue)))
        });
    }
    onEditUSCompanyAdditionalDetail(USCompanyAdditionalDetail) {
        this.enterRelationshipDetailsForm.get('USCompanyAdditionalDetails.detailsForm').reset({
            id: USCompanyAdditionalDetail.id,
            companyId: this.primaryData.companyId,
            compOwnTypeCode: USCompanyAdditionalDetail.compOwnTypeCode,
            compOwnTypeId: USCompanyAdditionalDetail.compOwnTypeId,
            firstName: USCompanyAdditionalDetail.firstName,
            lastName: USCompanyAdditionalDetail.lastName,
            middleName: USCompanyAdditionalDetail.middleName,
            corporateName: USCompanyAdditionalDetail.corporateName,
            nationality: USCompanyAdditionalDetail.nationality,
            immigrationStatusCode: USCompanyAdditionalDetail.immigrationStatusCode,
            immigrationStatusId: USCompanyAdditionalDetail.immigrationStatusId,
            ownershipPercent: USCompanyAdditionalDetail.ownershipPercent
        });
    }
    onDeleteUSCompanyAdditionalDetail(USCompanyAdditionalDetail) {
        this.apiEnterEntitiesRelationshipDetailsLibraryService
            .onDeleteUSCompanyAdditionalDetails(USCompanyAdditionalDetail.id, this.primaryData)
            .pipe(take(1), mergeMap(response => {
            if (response) {
                return this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetUSCompanyAdditionalDetails(this.primaryData);
            }
            else {
                return EMPTY;
            }
        }))
            .subscribe(responseUSCompanyAdditionalDetails => {
            this.setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails);
        });
    }
    onCompOwnTypeCode() {
        this.enterRelationshipDetailsForm.get('USCompanyAdditionalDetails.detailsForm')
            .patchValue({
            firstName: null,
            lastName: null,
            middleName: null,
            corporateName: null,
            immigrationStatusCode: null,
            immigrationStatusId: null
        });
    }
    addUSCompanyAdditionalDetails() {
        this.USCompanyAdditionalDetailsSubmited = true;
        const group = this.enterRelationshipDetailsForm.get('USCompanyAdditionalDetails.detailsForm');
        if (group.value.compOwnTypeCode && group.value.nationality &&
            ((group.value.compOwnTypeCode === 'INDIVIDUAL' &&
                (group.value.firstName && group.value.firstName.trim() !== '') &&
                (group.value.lastName && group.value.lastName.trim() !== '') && group.value.immigrationStatusId) ||
                (group.value.compOwnTypeCode === 'CORPORATE' &&
                    (group.value.corporateName && group.value.corporateName.trim() !== ''))) &&
            group.value.ownershipPercent !== null) {
            const payload = {
                compOwnTypeCode: group.value.compOwnTypeCode,
                compOwnTypeId: null,
                companyId: this.primaryData.companyId,
                firstName: group.value.firstName,
                id: group.value.id ? group.value.id : null,
                immigrationStatusCode: null,
                immigrationStatusId: group.value.immigrationStatusId,
                lastName: group.value.lastName,
                middleName: group.value.middleName,
                nationality: group.value.nationality,
                ownershipPercent: group.value.ownershipPercent,
                corporateName: group.value.corporateName
            };
            this.apiEnterEntitiesRelationshipDetailsLibraryService.onSaveUSCompanyAdditionalDetails(payload, this.primaryData)
                .pipe(take(1), mergeMap(response => {
                if (response) {
                    if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                        this.updateStepStatus('INPROGRESS');
                    }
                    this.onResetUSCompanyAdditionalDetails();
                    return this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetUSCompanyAdditionalDetails(this.primaryData);
                }
                else {
                    return EMPTY;
                }
            }))
                .subscribe(responseUSCompanyAdditionalDetails => {
                this.setUSCompanyAdditionalDetails(responseUSCompanyAdditionalDetails);
            });
        }
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadService.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.primaryData.caseType === 'I130' ?
                this.primaryData.caseType : this.primaryData.visatype,
            stepId: this.primaryData.stepId
        }));
    }
    onResetUSCompanyAdditionalDetails() {
        this.USCompanyAdditionalDetailsSubmited = false;
        this.resetForm.USCompanyAdditionalDetails.detailsForm = {
            id: null,
            companyId: this.primaryData.companyId,
            compOwnTypeCode: null,
            compOwnTypeId: null,
            firstName: null,
            lastName: null,
            middleName: null,
            corporateName: null,
            nationality: null,
            immigrationStatusCode: null,
            immigrationStatusId: null,
            ownershipPercent: null
        };
        this.enterRelationshipDetailsForm.get('USCompanyAdditionalDetails.detailsForm').reset(Object.assign({}, this.resetForm.USCompanyAdditionalDetails.detailsForm));
    }
    setFileUploadUSConfigurations() {
        let docTypeRefGroupCode = sync_entity_relationship_details_document_code.INVESTMENT_DOCUMENT_CODE;
        if (this.primaryData.visatype === 'E1') {
            docTypeRefGroupCode = sync_entity_relationship_details_document_code.TRADE_DOCUMENT_CODE;
        }
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getDocTypeApiUrl: `/${this.primaryData.visatype}/petitionType/${this.primaryData.petitionType}/group/${docTypeRefGroupCode}/documentTypes`,
            getApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${this.primaryData.caseId}/document/category/${docTypeRefGroupCode}/`,
            postApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${this.primaryData.caseId}/document/category/${docTypeRefGroupCode}/fileCategory/`,
            deleteApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${this.primaryData.caseId}/document/`,
            documentTypeDropdownCode: docTypeRefGroupCode
        });
    }
    onSubmit() {
        const formValue = this.enterRelationshipDetailsForm.value;
        const payload = {
            assets: formValue.assetsNetWorthNetAnnualIncomeDetails.assets,
            companyId: this.primaryData.companyId,
            id: formValue.id,
            invstmntCash: formValue.investmentDetailsE2.invstmntCash ? formValue.investmentDetailsE2.invstmntCash : 0,
            invstmntEquipment: formValue.investmentDetailsE2.invstmntEquipment ? formValue.investmentDetailsE2.invstmntEquipment : 0,
            invstmntInvntry: formValue.investmentDetailsE2.invstmntInvntry ? formValue.investmentDetailsE2.invstmntInvntry : 0,
            invstmntOther: formValue.investmentDetailsE2.invstmntOther ? formValue.investmentDetailsE2.invstmntOther : 0,
            invstmntPremise: formValue.investmentDetailsE2.invstmntPremise ? formValue.investmentDetailsE2.invstmntPremise : 0,
            netAnnualIncome: formValue.assetsNetWorthNetAnnualIncomeDetails.netAnnualIncome,
            netWorth: formValue.assetsNetWorthNetAnnualIncomeDetails.netWorth,
            numEmpBenSuprvs: formValue.otherRequiredDetails.numEmpBenSuprvs,
            numExecMngrEmpEHLStat: formValue.otherRequiredDetails.numExecMngrEmpEHLStat,
            numPosSpecQualEHLStat: formValue.otherRequiredDetails.numPosSpecQualEHLStat,
            numTotExecMngrEmp: formValue.otherRequiredDetails.numTotExecMngrEmp,
            numTotPosSpecQual: formValue.otherRequiredDetails.numTotPosSpecQual,
            principalProductOrServiceInfo: formValue.principalProductOrService.principalProductOrServiceInfo,
            relationshipBetCompanyInfo: formValue.relationshipBetCompany.relationshipBetCompanyInfo,
            totAnnualGrossTrade: formValue.TradeDetailsE1.totAnnualGrossTrade,
            totAnnualGrossTradeYrEnd: formValue.TradeDetailsE1.totAnnualGrossTradeYrEnd,
            totPercGrossTradeUSTrtyCntry: formValue.TradeDetailsE1.totPercGrossTradeUSTrtyCntry
        };
        this.apiEnterEntitiesRelationshipDetailsLibraryService.onSaveEntityRelationshipDetails(payload, this.primaryData)
            .pipe(take(1), mergeMap(response => {
            if (response) {
                if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                return this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetEntityRelationshipDetails(this.primaryData);
            }
            else {
                return EMPTY;
            }
        }))
            .subscribe(responseUSCompanyAdditionalDetails => {
            this.setEntityRelationshipDetails(responseUSCompanyAdditionalDetails);
        });
    }
    handleCancel() {
        this.apiEnterEntitiesRelationshipDetailsLibraryService.onGetEntityRelationshipDetails(this.primaryData)
            .pipe(take(1))
            .subscribe(responseUSCompanyAdditionalDetails => {
            this.setEntityRelationshipDetails(responseUSCompanyAdditionalDetails);
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseEnterEntitiesRelationshipDetailsLibraryService.ɵfac = function BaseEnterEntitiesRelationshipDetailsLibraryService_Factory(t) { return new (t || BaseEnterEntitiesRelationshipDetailsLibraryService)(i0.ɵɵinject(i1$1.DirtyFormGuard), i0.ɵɵinject(i2$1.Store), i0.ɵɵinject(i3.ReferenceLibraryService), i0.ɵɵinject(i4.CacheCountryListService), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(ApiEnterEntitiesRelationshipDetailsLibraryService), i0.ɵɵinject(i7.StepStatusUpdatePayloadService), i0.ɵɵinject(i8.StepStatusUpdateComponentLibraryService)); };
BaseEnterEntitiesRelationshipDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseEnterEntitiesRelationshipDetailsLibraryService, factory: BaseEnterEntitiesRelationshipDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseEnterEntitiesRelationshipDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.DirtyFormGuard }, { type: i2$1.Store }, { type: i3.ReferenceLibraryService }, { type: i4.CacheCountryListService }, { type: i2.ToastrService }, { type: ApiEnterEntitiesRelationshipDetailsLibraryService }, { type: i7.StepStatusUpdatePayloadService }, { type: i8.StepStatusUpdateComponentLibraryService }]; }, null); })();
class FroalaEditorOptions {
}
FroalaEditorOptions.EditorOptions = {
    placeholderText: 'Edit Your Content Here!',
    toolbarButtons: {
        moreText: {
            buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
        },
        moreParagraph: {
            buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
        },
        moreRich: {
            buttons: ['insertTable', 'insertHR', 'insertPageBreak', 'specialCharacters', 'embedly']
        },
        moreMisc: {
            buttons: ['undo', 'redo', 'help'],
            align: 'right',
            buttonsVisible: 2
        }
    },
    heightMin: 300,
    height: 350,
    heightMax: 600,
    listAdvancedTypes: true,
    wordPasteModal: false,
    wordPasteKeepFormatting: true,
    tableResizer: true,
    tableResizerOffset: 10,
    tableResizingLimit: 20,
    toolbarSticky: false,
    key: '7MD3aB3C2B3D5E4D3xROKLJKYHROLDXDRE1b1YYGRi1Bd1C4F4B3B2G3A15A15A12A4C4=='
};

/*
 * Public API Surface of base-enter-entities-relationship-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiEnterEntitiesRelationshipDetailsLibraryService, BaseEnterEntitiesRelationshipDetailsLibraryService, FroalaEditorOptions };
//# sourceMappingURL=base-enter-entities-relationship-details-library.js.map
